import angular from 'angular';

(function () {
    'use strict';
    var core = angular.module('app.kissuser');

    core.constant(
        'KISS_USER',
        Object.freeze({
            profil: [
                'ALL',
                'SALES_ADMIN',
                'ADMIN_GED',
                'ADMIN_FO',
                'APPROVER',
                'CUSTOMER_ACCOUNTANT',
                'SUPPLIER_ACCOUNTANT',
                'REQUESTER',
                'PURCHASING_MANAGER',
                'EXECUTIVE_INVBUY',
                'EXECUTIVE',
                'THREE_WAY_MATCHING_ACCOUNTANT',
                'ACCOUNTANT',
                'USER_GED',
                'USER_WKF',
            ],
            boRoleByLevel: [
                {
                    role: 'ADMIN',
                    level: 4,
                },
                { role: 'CONFIGURATOR', level: 3 },
                { role: 'SUPPORT', level: 2 },
                { role: 'USER_BO', level: 1 },
                { role: 'OPERATION', level: 3 },
                { role: 'PRODUCT', level: 3 },
            ],
            rolesTree: [
                { role: 'USER_BO', childs: [] },
                { role: 'SUPPORT', childs: ['USER_BO'] },
                { role: 'OPERATION', childs: ['USER_BO'] },
                { role: 'PRODUCT', childs: ['USER_BO'] },
                { role: 'CONFIGURATOR', childs: ['SUPPORT'] },
                { role: 'ADMIN', childs: ['OPERATION', 'PRODUCT', 'CONFIGURATOR'] },
            ],
            principal_profil: [
                'ALL',
                'CUSTOMER_ACCOUNTANT',
                'SUPPLIER_ACCOUNTANT',
                'ADMIN_FO',
                'USER_WKF',
                'SALES_ADMIN',
                'ADMIN_GED',
                'USER_GED',
            ],
            status: ['ALL', 'ACTIVE', 'INACTIVE', 'LOCKED'],
            userOwnerEntityType: ['SELLER', 'PRINCIPAL', 'BUYER'],
            pagination: {
                defaultPageSize: 20,
                defaultSort: [
                    {
                        direction: 'DESC',
                        property: 'seller',
                    },
                ],
                defaultPage: 0,
            },
            columnFieldMap: [
                {
                    field: 'seller.getSellerNameWithId()',
                    property: 'seller',
                },
                {
                    field: 'user.login',
                    property: 'login',
                },
                {
                    field: 'user.lastname',
                    property: 'lastname',
                },
                {
                    field: 'user.firstname',
                    property: 'firstname',
                },
                {
                    field: 'user.email',
                    property: 'email',
                },
                {
                    field: 'user.getRoleLabel()',
                    property: 'role',
                },
                {
                    field: 'user.getStatusLabel()',
                    property: 'status',
                },
            ],
        })
    );
})();
